import HTTP from '@/plugins/http';

const apiUrl = {
  report: '/report/home'
};

function getReport(params) {
  return HTTP({
    url: apiUrl.report,
    methods: 'get',
    params
  });
}

export { getReport };



// WEBPACK FOOTER //
// ./src/api/index.js